import webpackVars from './.webpack/webpack.vars.js';
import Swiper from 'swiper';
window.addEventListener('DOMContentLoaded', (event) => {

    const mobileBreakpoint = 992;

    let swiper;

    let $selectedButton = $('#getTheLookCategories ._selected');
    let selectedCategoryId = 0;

    if($selectedButton.length > 0) {
        selectedCategoryId = parseInt($selectedButton[0].value);
    }
    function initializeSlider() {

        swiper = new Swiper('#getTheLookCategories', {
            loop: false,
            slidesPerView: 'auto',
            pagination: false,
            navigation: false,
            spaceBetween: '5',
        });
    }



    initializeSlider();
    function selectCategory() {
        console.log('selectCategory',this.value);
        let categoryId = parseInt(this.value);

        if(selectedCategoryId === categoryId) return;

        let data = {
            ajax: 1,
            action: 'getProductsForCategory',
            id_category: categoryId
        }
        $.ajax({
            url: ajaxGetTheLookUrl,
            dataType: 'json',
            data: data
        }).then(function(response) {
            if(typeof response.productsPhotos !== 'undefined')
                $('#getTheLookProductPhotos').replaceWith(response.productsPhotos);

            selectedCategoryId = categoryId;
            $('#getTheLookCategories ._selected').removeClass('_selected');
            $('#getTheLookCategories button[value=' + selectedCategoryId + ']').addClass('_selected');
            console.log('#getTheLookCategories button[value=' + selectedCategoryId + ']',$('#getTheLookCategories button[value=' + selectedCategoryId + ']'));
        });
    }



    $(document).on('click', '#getTheLookCategories button', selectCategory);

});


if (module.hot) {
    console.log('#getTheLookCategories');
    var hotEmitter = require("webpack/hot/emitter");
    hotEmitter.on("webpackHotUpdate", function (currentHash) {
        const styles = document.getElementsByClassName('vue-hmr-reload');
        for (let style of styles)
            style.href = style.href.replace(/((\?|&)vdev=\d+)?$/, `$1vdev=${Date.now()}`)
    })

    window.addEventListener('DOMContentLoaded', (event) => {
        let links = document.getElementsByTagName("link");
        for (let link of links) {
            if (link.rel && link.rel === 'stylesheet')
                if (link.href.match('/cv_photo_product_gallery/')) {
                    link.href = link.href.replace(/(http(s)+:|)(^|\/\/)(.*?\/)/g, webpackVars.getDevServerUrl() + '/')
                        + (link.href.indexOf('?') >= 0 ? '&' : '?')
                        + `vdev=${Date.now()}`;
                    link.classList.add("vue-hmr-reload");
                }
        }

    });
}
